import { Menu } from "@mui/icons-material"
import { IconButton, Stack, Typography } from "@mui/material"

import PageHeader from "@components/page_header"
import { PRIMARY } from "@constants/colors"

import { useScriptsPageContext } from "@contexts/main/scripts_page_context"
import styles from "./styles"

export default function ScriptsPageHeader() {
  const { translate, isLeftDrawerOpen, toggleIsLeftDrawerOpen } =
    useScriptsPageContext()

  return (
    <PageHeader sx={styles.content} isLeftPanelOpen={isLeftDrawerOpen}>
      <Stack direction={"row"} alignItems={"center"} columnGap={1}>
        <IconButton
          onClick={toggleIsLeftDrawerOpen}
          disabled={!!isLeftDrawerOpen}
          disableRipple
          sx={{
            display: !!isLeftDrawerOpen ? "none" : "block",
            pl: 0,
            ":hover": {
              color: PRIMARY
            }
          }}
        >
          <Menu />
        </IconButton>

        <Typography variant="h6">{translate("scripts_tooltip")}</Typography>
      </Stack>
    </PageHeader>
  )
}
